import { render, staticRenderFns } from "./DeleteItemGrammar.vue?vue&type=template&id=c0eae89a&scoped=true&"
import script from "./DeleteItemGrammar.vue?vue&type=script&lang=js&"
export * from "./DeleteItemGrammar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eae89a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
